import React from "react";
import Chat from "./Chat";

const App = () => {
  return (
    <div className="app-container">
      <h1>NooriTalk Islamic Chat</h1>
      <Chat />
    </div>
  );
};

export default App;
